<template>
    <div class="main-container" v-show="node.filename">
        <div class="header">
            <van-nav-bar left-text="查看详情" :left-arrow="canReturn"  @click-left="onClickLeft"/>
        </div>
        <div class="content" style="">
            <div class="content-header van-hairline--bottom">
                <div class="thumb" @click="onPreview">
                    <kabala-fileicon :node="node.node" :moreinfo="true"></kabala-fileicon>
                </div>
                <div class="thumb-btn" @click="" style="display: none">
                    <van-icon name="more-o"/>
                </div>
            </div>
            <div class="detail">
                <div class="detail-item" v-show="node.filename.length > 10">
                    <div class="title ft-14">文件名称</div>
                    <div class="desc ft-16">{{ node.filename }}</div>
                </div>

                <div class="detail-item" v-if="node.node.isfile">
                    <div class="title ft-14">文件版本</div>
                    <div class="desc ft-16">V{{ node.versionnum }}</div>
                </div>

                <div class="detail-item" v-if="node.cuser">
                    <div class="title ft-14">修改人</div>
                    <div class="desc ft-16">{{ node.cuser }}</div>
                </div>

                <div class="detail-item" v-if="node.ctime">
                    <div class="title ft-14">修改时间</div>
                    <div class="desc ft-16">{{ node.ctime }}</div>
                </div>

                <div class="detail-item" v-if="node.systagArr.length > 0">
                    <div class="title ft-14">文件密级</div>
                    <div class="desc ft-16">
                        <div>
                            <ul v-for="tag in node.systagArr" :key="tag">
                                <li>{{ tag }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="detail-item" style="display: none">
                    <div class="title ft-14">锁定信息</div>
                    <div class="desc ft-16">{{ node.lockinfo }}</div>
                </div>

                <div class="detail-item" v-if="node.usertagArr.length > 0 ">
                    <div class="title ft-14">
                        文件标签
                        <span
                            v-show="node.usertagArr.length > 4"
                            class="more"
                            @click="doshowmoretag"
                        >{{ showmoretag ? "收起" : "查看更多" }}</span
                        >
                    </div>
                    <div class="desc ft-16">
                        <div class="file-tag">
                            <ul>
                                <li v-for="tag in showusertagArr" :key="tag">{{ tag }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="detail-item pms">
                    <div class="title ft-14">
                        文件权限
                        <span
                            v-show="node.permissionArr.length > 4"
                            class="more"
                            @click="showmorepms = !showmorepms"
                        >{{ showmorepms ? "收起" : "查看更多" }}</span
                        >
                    </div>
                    <div class="desc ft-16">
                        <div :class="{ 'van-ellipsis': !showmorepms }">
                            {{ permissionstrAll }}
                        </div>
                    </div>
                </div>

                <div class="detail-item">
                    <div class="title ft-14">文件路径</div>
                    <div class="desc ft-16">{{ node.showpath }}</div>
                </div>
            </div>
        </div>
        <van-popup v-model="showpreview" get-container="#app" duration="0.1" style="width: 100%;height: 100%;">
            <div style="width: 100%; height:calc(100% - 55px);">
                <div @click="closePreivew" style="height: 55px;line-height:55px; padding-left:16px; font-size:4.266667vw; font-weight: bold;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow" style="position:relative;top: 2px;"></i>预览</div>
                <div style="box-sizing: border-box;background: #fff;position: relative;height: 100%;">
                    <iframe :src="url" style="width:100%;height:100%;border:none;"></iframe>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>

import {Toast} from 'vant';
import $kspace from "@/kabala/js/kspace";
import KabalaFileicon from "@/components/common/kabala-fileicon";

export default {
    props: {
      path:{
        type:String,
        default:"",
      },
      canReturn:{
        type:Boolean,
        default: false
      },
      callback:{
        type:Function,
        default:null
      }
    },
    components: {KabalaFileicon},
    data() {
        return {
            activeNames: ["1"],
            currentPath: "", // 当前路径
            node: {
                filename: "",
                node: {},
                systagArr: [],
                usertagArr: [],
                metaArr: [],
                permissionArr: [],
            }, //节点
            filelength: 1, // 显示的文件数量 默认一个文件
            filename: "", // 显示的文件名称 若有多个文件 只显示第一个文件名称
            fileicon: "", // 显示的图标
            showmorepms: false, // 显示更多权限内容
            showmoretag: false, // 显示更多文件标签
            showusertagArr: [],
            showpreview: false,
            url:'',
        };
    },
    computed: {
        // 权限列表
        permissionstrAll() {
            if (this.node.permissionArr) {
                return this.node.permissionArr.filter((item) => !!item).join("、");
            } else {
                return "";
            }
        },
    },
    created: function () {


    },
    mounted() {
        let path = this.path;
        if (path) {
            this.currentPath = path;
            this.doGetnodes();
        }
    },
    methods: {
      onClickLeft:function(){
        console.log('clickleft', this.canReturn)
        if(this.canReturn){
          this.callback && this.callback();
        }
      },
        doGetnodes: function () {
            $kspace
                .getnodes([this.currentPath])
                .then((datas) => {
                    this.buildData(datas);
                    this.node = datas[0];
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        // 构建属性标签
        buildExtMetas: function (metas) {
            const rulemetas = this.$khttp.getSync("/api/pan/prop", {
                op: "getrulelist",
            });
            const retArr    = [];
            for (let i = 0; i < metas.length; i++) {
                for (let j = 0; j < rulemetas.length; j++) {
                    if (metas[i].key === rulemetas[j].metakey) {
                        if (rulemetas[j].metatype === "txtmeta") {
                            let index = rulemetas[j].ruletxt.indexOf("{seq");
                            if (
                                (index === -1 &&
                                    metas[i].value.indexOf(rulemetas[j].rule) === -1) ||
                                (index > -1 &&
                                    metas[i].value.indexOf(
                                        rulemetas[j].ruletxt.substring(0, index)
                                    ) === -1)
                            ) {
                                continue;
                            }
                        }
                        let obj = {
                            showkey: rulemetas[j].showname,
                            showvalue: metas[i].value,
                            key: metas[i].key,
                            value: metas[i].value,
                            metatype: rulemetas[j].metatype,
                        };
                        retArr.push(obj);
                    }
                }
            }
            return retArr;
        },
        // 构建节点展示数据
        buildData: function (datas) {
            console.log('构建节点展示数据<<<', datas)
            if (datas) {
                for (var i = 0; i < datas.length; i++) {
                    let filenode = this.$MobileApi.extendAttrs({}, datas[i]);

                    datas[i]          = {node: filenode}; //
                    let path          = filenode.showpath ? filenode.showpath : filenode.filepath;
                    datas[i].id       = this.$kutil.random() + "_" + i; //id
                    datas[i].isfile   = filenode.isfile; //
                    datas[i].filename = path.getName(); //名字
                    datas[i].filepath = filenode.path; //路径
                    datas[i].showpath = this.$kutil.parseshowpath(filenode.path, filenode.showpath);

                    //信息
                    datas[i].lockinfo = "-";
                    if (datas[i].lockuser) {
                        datas[i].lockinfo =
                            this.$kuser.getname(this.currentnode.lockuser) +
                            this.$t("pan.text.on") +
                            this.$kutil.formatTime(this.currentnode.locktime) +
                            this.$t("pan.text.lock");
                    }

                    // 标签
                    const systagArr  = [];
                    const usertagArr = [];
                    if (datas[i].node.tags) {
                        datas[i].node.tags.forEach((tag) => {
                            if (tag.tagtype === "systag") {
                                systagArr.push(tag.tagname);
                            }
                            if (tag.tagtype === "usertag") {
                                usertagArr.push(tag.tagname);
                            }
                        });
                    }
                    datas[i].systagArr  = systagArr;
                    datas[i].usertagArr = usertagArr;
                    // datas[i].usertagArr = ['a','a','c','a','c','a','c','a','c','a','c','a','c','a','c','a','c',];
                    this.showusertagArr = datas[i].usertagArr.slice(0, 4);

                    // 权限
                    try {
                        const permissionNum    =
                                  $kpermission.TenantDoc.sync.queryMyPermissions([
                                      datas[i].node.path,
                                  ]);
                        var nums               = permissionNum[datas[i].node.path];
                        datas[i].permissionArr = $kpermission.getNumbers2Names(
                            $kpermission.pmsSum2Nums(nums)
                        );
                    } catch (e) {
                        console.log(e);
                        datas[i].permissionArr = [];
                    }

                    //属性
                    if (datas[i].node.metas) {
                        datas[i].metaArr = this.buildExtMetas(datas[i].node.metas);
                    } else {
                        datas[i].metaArr = [];
                    }

                    //时间
                    if (filenode.ctime && filenode.ctime != -1) {
                        datas[i].ctime = this.$kutil.dateFormat(
                            this.$kutil.formatDateObject(filenode.ctime),
                            "yyyy-MM-dd HH:mm"
                        );
                    } else {
                        datas[i].ctime = "";
                    }


                    datas[i].space = this.space;
                    if (filenode.cuser && filenode.cuser.length > 0) {
                        datas[i].cuser = this.$kuser.getname(filenode.cuser); //管理员
                    } else {
                        datas[i].cuser = "";
                    }

                    if (filenode.isfile) {
                        let filever       = filenode.versions[filenode.versions.length - 1]; //版本
                        datas[i].datasize = this.$kutil.formatSize(filever.datasize); //大小
                        datas[i].icon     = this.$kutil.iconUrl(path); //链接
                        //
                        if (
                            filenode.versions &&
                            filenode.versions[0] &&
                            filenode.versions[0].showversion
                        ) {
                            datas[i].versionnum = filenode.versions[0].showversion;
                        } else {
                            datas[i].versionnum = filenode.versions.length;
                        }
                    } else {
                        datas[i].icon = "/kabala/images/mobile/folder.png";
                    }
                }
            }
        },
        // 显示更多标签
        doshowmoretag: function () {
            if (this.showmoretag) {
                if (this.node.usertagArr.length > 0) {
                    this.showusertagArr = this.node.usertagArr.slice(0, 4);
                } else {
                    this.showusertagArr = [];
                }
            } else {
                if (this.node.usertagArr.length > 0) {
                    this.showusertagArr = this.node.usertagArr;
                } else {
                    this.showusertagArr = [];
                }
            }

            this.showmoretag = !this.showmoretag;
        },
        onPreview: function () {
            if(!this.node.node.isfile){return;}
            let that = this;

            $kspace.askviewurl(this.node.node.path, "", 60).then(function (url) {
                that.showpreview = true;
                that.url =url;
            }).catch(function (e) {
                console.log(e);
                Toast.fail(e);
            })
        },
        closePreivew(){
            this.showpreview =false;
            this.url = '';
        }
    },
};
</script>

<style scoped>
.ft-14 {
    font-size: 3.733333vw;
}

.ft-16 {
    font-size: 4.266667vw;
}

.main-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
}

.content {
    box-sizing: border-box;
    background: #fff;
    position: relative;
    padding-top: 60px;
}

.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    height: 55px;
    background: #fff;
}

.header >>> .van-nav-bar__content {
    height: 55px;
}

.header >>> .van-nav-bar__text {
    max-width: 50vw;
    height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 4.266667vw;
    color: #333;
    font-weight: bold;
}

.header >>> .van-icon-arrow-left::before {
    color: #333;
    font-size: 4.266667vw;
}

.header >>> .van-nav-bar__left {
    padding-left: 3.733333vw;
}

.content {
    overflow: hidden;
}

.content-header {
    position: relative;
    margin: 0 3.733333vw 2.666666vw;
    padding: 3.7333333vw 0;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.thumb {
    display: flex;
    align-items: center;
    width: 100%;
}

.thumb >>> .van-cell {
    padding: 0;
}

.thumb-btn {
    display: flex;
    width: 12%;
    padding: 10px 0;
    align-items: center;
    justify-content: flex-end;
}

.detail {
    padding: 0 4.733333vw;
}

.detail-item {
    margin-bottom: 5.866667vw;
}

.title {
    color: #b2b2ba;
    margin-bottom: 1.333333vw;
}

.desc {
    color: #3e3737;
}

/*文件标签*/
.file-tag ul {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.file-tag ul li {
    display: inline-block;
    font-size: 4.2666667vw;
    margin-bottom: 0.5em;
    margin-right: 1.33333vw;
    padding: 0.5em;
    line-height: 1em;
    background-color: #40abfc;
    color: #fff;
    border-radius: 2em;
}

/*权限*/
.pms {
    position: relative;
}

.more {
    color: #42a2fb;
    margin-left: 1.3333vw;
}
</style>
